module.exports = __webpack_public_path__ + "img/21.616dffa3.png";